(function() {
  if (App.angularApp == null) {
    return;
  }

  App.angularApp.directive('mfUiSelectButton', function() {
    return {
      require: 'uiSelect',
      restrict: 'A',
      link: function(scope, ele, attrs, ctrl) {
        return ele.on('click', '#ui-select-button', function(e) {
          return scope.$eval(attrs.mfUiSelectButton);
        });
      }
    };
  });

}).call(this);
